/**
 * Lista de cargos para formulários
 * Usado em selects nos formulários de cadastro e edição
 */

const cargos = [
  'Conselheiro Administrativo',
  'Conselheiro de Administração Independente',
  'Conselheiro Fiscal',
  'Diretor',
  'Diretor Adjunto',
  'Diretor Administrativo',
  'Diretor Administrativo e Financeiro',
  'Diretor Comercial',
  'Diretor de Informática',
  'Diretor de Produção',
  'Diretor Financeiro',
  'Diretor Gerente',
  'Diretor Operacional',
  'Diretor Presidente',
  'Diretor sem Designação',
  'Diretor Superintendente',
  'Diretor Técnico',
  'Presidente do Conselho Administrativo',
  'Procurador'
];

export default cargos;